import { Chart } from 'chart.js';

// Simple plugin to draw numeric labels on bars/points and an optional goal line
export const DataLabelAndGoalPlugin = {
  id: 'dataLabelAndGoal',
  afterDatasetsDraw: (chart) => {
    const { ctx, data, chartArea, scales } = chart;
    ctx.save();

    // draw data labels for bar datasets
    data.datasets.forEach((dataset, di) => {
      const meta = chart.getDatasetMeta(di);
      if (!meta || !meta.data) return;
      meta.data.forEach((element, index) => {
        const value = dataset.data[index];
        if (value == null) return;
        const position = element.tooltipPosition();
        ctx.fillStyle = '#000';
        ctx.font = '12px Arial';
        ctx.textAlign = 'center';
        ctx.fillText(typeof value === 'number' ? value.toLocaleString() : String(value), position.x, position.y - 6);
      });
    });

    // draw goal line if configured
    const goal = chart.options.plugins?.goalLine;
    if (goal && typeof goal.value === 'number') {
      const y = scales.y.getPixelForValue(goal.value);
      ctx.strokeStyle = goal.color || 'red';
      ctx.lineWidth = goal.lineWidth || 2;
      ctx.setLineDash(goal.dash || [6,4]);
      ctx.beginPath();
      ctx.moveTo(chartArea.left, y);
      ctx.lineTo(chartArea.right, y);
      ctx.stroke();
      ctx.setLineDash([]);
      // label
      if (goal.label) {
        ctx.fillStyle = goal.color || 'red';
        ctx.font = '12px Arial';
        ctx.textAlign = 'right';
        ctx.fillText(goal.label, chartArea.right - 6, y - 6);
      }
    }

    ctx.restore();
  }
};

Chart.register(DataLabelAndGoalPlugin);

export function niceMax(dataValues) {
  const max = Math.max(...dataValues.filter(v => typeof v === 'number').map(v => v || 0), 0);
  if (max === 0) return 1;
  const power = Math.pow(10, Math.floor(Math.log10(max)));
  const rounded = Math.ceil(max / power) * power;
  return rounded;
}
